<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger" [class.-is-open]="isPanelOpened" (click)="isPanelOpenedChange.emit(!isPanelOpened)">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Addresses section title@@customerOverviewComponent.heading.ticketing'>Ticketing</span>
    </h4>
  </div>

  <div class="esf-accordion__target -is-open" [hidden]="!isPanelOpened">

    <div class="esf-horizontal-tabs">
      <ul class="esf-horizontal-tabs__list esf-horizontal-tabs__list--no-margin">
        <li class="esf-horizontal-tabs__list-item">
          <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="currentlyOpened === 'invoices' ? true : null"
                (click)="setCurrentlyOpened('invoices')" i18n='Text in a tab element@@general.tabs.invoices'>Invoices</span>
        </li>
        <li class="esf-horizontal-tabs__list-item" *ngIf="!selectedClub.isDataFeedActive">
          <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="currentlyOpened === 'reservations' ? true : null"
                (click)="setCurrentlyOpened('reservations')">
            <span [ngClass]="{'esf-badge': bookableReservations !== 0}" [attr.data-badge]="bookableReservations"
                  i18n='Text in a tab element@@general.tabs.reservations'>Reservations</span>
          </span>
        </li>
        <li class="esf-horizontal-tabs__list-item">
          <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="currentlyOpened === 'cancellations' ? true : null"
                (click)="setCurrentlyOpened('cancellations')" i18n='Text in a tab element@@general.tabs.cancellations'>Cancellations</span>
        </li>
      </ul>
      <div class="esf-horizontal-tabs__panels">

        <section class="esf-horizontal-tabs__panel" id="invoices" *ngIf="isCurrentlyOpened('invoices')">
          <app-customer-invoices-list [customer]="customer"></app-customer-invoices-list>
        </section>

        <section class="esf-horizontal-tabs__panel" id="reservations" *ngIf="isCurrentlyOpened('reservations')">
          <app-customer-reservations-list [customer]="customer" [tixxReservationsTimedOut]="tixxReservationsTimedOut"></app-customer-reservations-list>
        </section>

        <section class="esf-horizontal-tabs__panel" id="cancellations" *ngIf="isCurrentlyOpened('cancellations')">
          <app-customer-cancellations-list [customer]="customer"></app-customer-cancellations-list>
        </section>
      </div>
    </div>

  </div>
</div>
